import { Form } from "react-bootstrap";
import './Select.css';

export default function Select({ label, placeholder, options = [], value, onChange, style, id, divClassname, icon, disabled, testId }) {
    return (
        <div className={`custom-dropdown ${divClassname}`}>
            <Form.Label htmlFor={id} className="label">{label}</Form.Label>
            {icon}
            <div className="select-wrapper">
                <Form.Select
                    value={value || ""}
                    onChange={(e) => {
                        onChange(e.target.value);
                    }}
                    id={id}
                    style={style}
                    disabled={disabled}
                    data-testid={testId}
                >
                    <option value="" disabled>{placeholder}</option>
                    {options.map(item => (
                        <option key={item.value} value={item.value}>{item.text}</option>
                    ))}
                </Form.Select>
            </div>
        </div>
    );
}